module.exports = __webpack_public_path__ + "static/media/logo-cm.adb003f4.webp";